var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":_vm.siteKey,"data-callback":_vm.onVerify,"data-expired-callback":_vm.onExpired}})])
}
var staticRenderFns = []

export { render, staticRenderFns }